import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'aa-view-ch2',
    templateUrl: './view-ch2.component.html',
    styleUrls: [
        './view-ch2.component.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ViewCh2Component
{
}
